import { createFileRoute } from '@tanstack/react-router';
import UploadPage from 'src/UploadPage/UploadPage';
import { requireAuth } from 'src/utils/authGuard';

export const Route = createFileRoute('/upload')({
  beforeLoad: () => {
    requireAuth();
  },
  component: UploadPage,
});
